<template>
  <b-modal v-model="second" id="modAgregarCita" title="La sesión está por expirar" ok-only>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    Tu sesión esta por expirar en {{ time/1000 }} segundos. Mueve el mouse para seguir en la sesión
  </b-modal>
</template>

<script>
export default {
  data() {
    return {
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,
      second: true,
      time: 10000 //10 segundos tolerancia para el cierre automatico
    }
  },
  created() {
    this.debug = this.$localStorageService.getDebug();
    let timerId = setInterval(() => {
      this.time -= 1000;
      if (!this.$store.state.idleVue.isIdle) clearInterval(timerId);

      if (this.time < 1) {
        clearInterval(timerId);
        this.$session.destroy();
        this.$router.push({
          name: "login"
        });
        this.$store.state.idleVue.isIdle = false;
      }
    }, 1000);
  }
};
</script>